import React from 'react';

import { Checkbox, ListItemText, MenuItem, TextField } from '@material-ui/core';

interface MultiSelectFilterProps {
  label: string;
  items: Array<{ value: string; label: string }>;
  values?: string[];
  onSelect?: (values: string[]) => void;
}

const MultiSelectFilter: React.FC<MultiSelectFilterProps> = ({
  label,
  items,
  values,
  onSelect,
}) => {
  const handleChange = (
    e: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>,
  ) => {
    onSelect && onSelect(e.target.value as string[]);
  };

  return (
    <TextField
      fullWidth
      select
      label={label}
      variant="outlined"
      value={values ?? []}
      disabled={items.length === 0}
      SelectProps={{
        MenuProps: { variant: 'menu' },
        multiple: true,
        renderValue: () =>
          values
            ?.map((value) => items.find((item) => item.value === value)?.label)
            .join(', ') ?? '',
      }}
      onChange={handleChange}
    >
      {items.map(({ label, value }) => {
        const checked = values && values.indexOf(value) > -1;
        return (
          <MenuItem key={`${value} ${checked}`} value={value}>
            <Checkbox checked={checked} />
            <ListItemText primary={label} />
          </MenuItem>
        );
      })}
    </TextField>
  );
};

export default MultiSelectFilter;
